import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { logSelectors } from "../../../../redux/app/logs";
import { marpolSelectors } from "../../../../redux/app/marpol";
import {
	EORB4RecordCode,
	EORB4RecordState,
	TORB4BackendRecord,
} from "../../../../redux/app/orb4/@types";
import { vesselSelectors } from "../../../../redux/app/vessel";
import { IStore } from "../../../../redux/store";
import MARPOLRecordParticipantsView from "../_elements/ParticipantsView";
import ORB4Previewer from "../orb2/ORB4Previewer";

type OwnProps = {
	disabled: boolean;
};
type ORB2DocsProps = OwnProps;
function ORB2Docs(props: ORB2DocsProps & PropsFromRedux) {
	const { disabled, marpolDocs } = props;

	if (disabled)
		return (
			<div className="w-full h-64 text-gray-500 bg-gray-500 rounded-lg opacity-50">
				Disabled MARPOL DOCS
			</div>
		);

	if (marpolDocs.length === 0)
		return (
			<div className="flex flex-col flex-1 max-h-full mb-2">
				<div className="flex flex-row w-full max-h-full overflow-y-auto ws-scroll">
					<div className="flex-1 ">
						<h1 className="p-6 text-sm font-medium border border-gray-200 rounded-sm">
							No records found..
						</h1>
					</div>
				</div>
			</div>
		);

	return (
		<div className="w-full p-0 pt-6">
			<div className="mb-8">
				<h1 className="text-xl font-bold font-redhat-display">
					Oil Record Book (Part 2)
				</h1>
				<h1 className="w-3/4 mb-6 text-base font-medium leading-5 tracking-wide text-gray-600">
					Cargo/Ballast Operations.
				</h1>
			</div>
			<div className="w-full bg-gray-100">
				<table className="w-full bg-gray-100">
					<thead>
						<tr className="bg-gray-100">
							<th>
								<div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-left text-gray-600 bg-gray-200 border-gray-300 whitespace-nowrap">
									Date <span className="invisible"> and Time (UTC)</span>
								</div>
							</th>
							<th>
								<div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-center text-gray-600 bg-gray-200 border-gray-300 whitespace-nowrap min-w-20">
									Code
								</div>
							</th>
							<th>
								<div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-right text-gray-600 bg-gray-200 border-gray-300 whitespace-nowrap min-w-20">
									Item
								</div>
							</th>
							<th>
								<div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-left text-gray-600 bg-gray-200 border-gray-300 whitespace-nowrap min-w-20">
									Record of Operations
								</div>
							</th>
						</tr>
					</thead>
					<tbody>
						{marpolDocs.map((orbRecord, index) => {
							return (
								<React.Fragment key={orbRecord._rev}>
									<ORB4Previewer orbRecord={orbRecord} />
									<MARPOLRecordParticipantsView
										isSubmitterChiefOrMaster={false}
										record={orbRecord}
									/>
								</React.Fragment>
							);
						})}
					</tbody>
				</table>
			</div>
			<div className="px-3 py-5 mt-6 text-right">
				<span className="ml-auto text-sm font-medium text-gray-600">
					Powered by - <strong className="font-bold">Volteo Maritime</strong>
				</span>
			</div>
		</div>
	);
}

function mapStateToProps(store: IStore) {
	const logStore = logSelectors._getStore(store);
	const vesselStore = vesselSelectors._getStore(store);
	const marpolStore = marpolSelectors._getStore(store);

	return {
		areVesselsPresent: vesselSelectors.areVesselsPresent(store.app.vesselStore),
		filterForm: logSelectors.formForFilter(logStore),
		marpolDocs: marpolSelectors.getDocs(marpolStore) as TORB4BackendRecord[],
		miniVessels: vesselSelectors.getMiniVessels(
			vesselSelectors.getVessels(vesselStore)
		),
		jobToFilterLogs: logSelectors.jobToFilterLogs(logStore),
		jobToLoadSelectedLog: logSelectors.jobToLoadSelectedLog(logStore),
		jobToLoadVessels: vesselSelectors.jobToLoadVessels(vesselStore),
	};
}
function mapDispatchToProps(dispatch: Dispatch) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(ORB2Docs);
